<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import MailingList from "@/components/crm/mailingList.vue";

/**
 * Starter component
 */
export default {
    page: {
        title: "Mailing List",
        meta: [{ name: "description", content: appConfig.description }],
    },
    components: { Layout, PageHeader, MailingList },
    data() {
        return {
            title: "Mailing List",
            items: [
                {
                    text: "Utility",
                    active: true,
                },
            ],
        };
    },
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <MailingList />
    </Layout>
</template>
